// extracted by mini-css-extract-plugin
export var circle = "slogans-module--circle--VKwKD";
export var circled = "slogans-module--circled--Ivwnt";
export var container = "slogans-module--container--sZIaa";
export var marked = "slogans-module--marked--02U5W";
export var slogan = "slogans-module--slogan--tsETR";